<template>
  <div>
	   	
	   <div  id="container" style="height:600px;"></div>
		<DxPopup
      :visible.sync="paused "
      :drag-enabled="true"
	  :shading="false"
      :close-on-outside-click="false"
      :show-title="true"
      :width="300"
      :height="50"
      title="Paused: Space Toggles"
    >
	</DxPopup>
	<DxPopup
      :visible.sync="loadingModel"
      :drag-enabled="true"
	  :shading="false"
      :close-on-outside-click="false"
      :show-title="true"
      :width="300"
      :height="50"
      :title="loadName+' '+(loadedCount+1)+' of '+(loadingCount+1)"
    >   
    </DxPopup>
	<DxPopup
      :visible.sync="leavingExhibit"
      :drag-enabled="false"
	  :shading="true"
      :close-on-outside-click="false"
      :show-title="false"
      :width="300"
      :height="50"
      title="Loading Model..."
    >   
	Leaving the Exhibition
    </DxPopup>
		<DxPopup
      :visible.sync="popupVisible"
      :drag-enabled="false"
      :close-on-outside-click="true"
      :show-title="true"
      :width="300"
      :height="300"
      title="The Exhibition"
    >
	<br><br>
	
		W:Forward<br>
		A:left<br>
		S:Back<br>
		D:Right<br>
<br>
		
		Space:Play/Pause<br>
      
      
    </DxPopup>
	<div v-if="false && isTester" class="debug">{{position}}</div>
	<div class="CTA" ref="CTA"> 
			
			<div>
			<h2 v-if="exhibitOpen">Your exhibition is open to the public.<br><br>
			</h2>
			<h2 v-else>Your exhibition is private.<br><br>
			You can open the exhibition to the public when it is ready.</h2>
			<button v-if="exhibitOpen" @click="closeExhibition">Close Exhibition</button>
			<button v-else @click="openExhibition">Open Exhibition</button>
			<button v-if="!exhibitOpen" @click="closeCTA">Keep Private</button>
			<button v-else @click="closeCTA">Keep Public</button>
			<button @click="backToPlanning">Back to Planning</button>
			<button @click="backToLighthouse">Back to Lighthouse</button>
			<div v-if="exhibitOpen" style="pointer-events:auto;font-size:15px" ><a style="color:#fff" :href="'publicexhibition?wreck='+activeWreck+'&uid='+userData.id" target=”_blank”>Share this link to let other view your exhibition</a></div>
			</div>
			
		</div>
  </div>
</template>

<script>

var paused=false
var loadingModel=false


export default {
   	components: {
		   DxPopup,
		   
  },

		data: () => ({
			loadedCount:0,
			loadingCount:0,
			openSign:null,
			loadProgress:0,
			defaultImage:false,
			loadName:"Loading Room",
			video:null,
			hasVideo:false,
			leavingExhibit:false,
			popupVisible: false,
			paused:false,
			loadingModel:true,
			position:{x:0,y:0,z:0},
			rotation:0,
			distance:0,
			north:0,
			rotInfo:0,
			lights:[],
			ctx:null,
			plinthOpts:{spotTargetX:-5,
						spotAngle:12,
						lightType:spot1,
						objOffsetX:80,
						objOffsetY:0,
						objOffsetZ:0,
						model:plinth1
						},
			floorOpts:{spotTargetX:-5,
						spotAngle:12,
						lightType:spot1,
						objOffsetX:80,
						objOffsetZ:0,
						model:plinthF
						},
										
			frameOpts:{spotTargetX:18,
						spotAngle:8,
						lightType:frameSpot1,
						objOffsetX:90,
						objOffsetZ:0,
						model:frame1
						},
			screenOpts:{spotTargetX:18,
						
						objOffsetX:-90,
						objOffsetZ:-90,
						model:screen1,
						interactive:true,
						name:"Screen"
						}
		}),
		mounted(){
			this.$store.commit("setSettingsClass","settingsIcon exhibit")
			vueApp=this
			if(!this.wrecks){
				this.$store.dispatch("loadWrecks")
				return
			}
      		this.startScene()
		},
		computed:{
			fireBaseLoc(){
				return this.$store.getters.getFireBaseLoc					
			},
			userData(){
				  return this.$store.getters.getUserData
			},
			debug(){
      			return this.$store.getters.getDebug
    		},
			isTester(){
				return this.$store.getters.getIsTester
			},
			wrecks(){
     			return this.$store.getters.getWrecks
      		},
      		activeWreck(){
				if(this.gameStatus){
					return this.gameStatus.activeWreck
				}
			},
			gameStatus(){
				return this.$store.getters.getGameStatus
			},
			activeWreckStatus(){	
				return this.$store.getters.getActiveWreck
			},
			loadExhibitionWreck(){
				return this.$store.getters.getExhibitModel
			},
			exhibitionLoaded(){
				return this.$store.getters.getExhibitionLoaded
			},
			volume(){
				return this.$store.getters.getVolume
			},
			
			photos(){
				let photos=this.$store.getters.getPhotos
				if(photos && photos.length>0){
				  return this.$store.getters.getPhotos
				}
				this.defaultImage=true
				return  ["image1.png","image2.png","image4.png","image5.png"]			
			},
			wreckVid(){
				if(this.wreck && this.wreck.videoToken){
					return this.fireBaseLoc +"wrecks%2F"+this.wreck.videoToken
				}
			},
		
			exhibitOpen(){
				if(this.exhibitionLayout){
					return this.exhibitionLayout.open
				}
			},
			exhibitionLayout(){
				return this.$store.getters.getExhibitLayout
			},
			exhibitMode(){
				return this.$store.getters.getExhibitMode
			},
			wreck(){
				console.log(this.$store.getters.getWreck)
				return this.$store.getters.getWreck
    		},
		},
		methods:{
			openCTA(){
				gsap.to(this.$refs.CTA,1,{autoAlpha:1})
			},
			closeCTA(){
				gsap.to(this.$refs.CTA,1,{autoAlpha:0})
			},
			openExhibition(){
				this.exhibitionLayout.open=true
				this.$store.dispatch('saveExhibition')
				vueApp.writeSign(vueApp.wreck.name )
							var cTexture=  new THREE.CanvasTexture(vueApp.ctx.canvas);
							var label = new THREE.MeshBasicMaterial({ map:cTexture}) 
							vueApp.openSign.material=label
							vueApp.openSign.material.map.flipY=false
			},
			closeExhibition(){
				this.exhibitionLayout.open=false
				this.$store.dispatch('saveExhibition')
				vueApp.writeSign(vueApp.wreck.name )
							var cTexture=  new THREE.CanvasTexture(vueApp.ctx.canvas);
							var label = new THREE.MeshBasicMaterial({ map:cTexture}) 
							vueApp.openSign.material=label
							vueApp.openSign.material.map.flipY=false
			},
			backToPlanning(){
				this.$store.dispatch('startTransition',{text:"Back at the drawing board",to:"exhibitPlan"})
			},
			backToLighthouse(){
				this.$store.dispatch('startTransition',{text:"Back at the Lighthouse",to:"game"})	
			},
			startScene(){
				this.loadRoomModel()
				init();
				isRunning=true
				animate();
				requestAnimationFrame( this.checkStatus );
				document.addEventListener('keyup', this.keyUp);
				//position.z=400
				console.log("Wreck ",this.wreck)
				console.log("Wreck Vid",this.wreckVid)
			
      
			},
			writeSign(heading){
			
			var canvas = document.createElement('canvas');
			canvas.width = 400;
			canvas.height = 300;
			//var canvas = document.getElementById(canvasID);
			this.ctx = canvas.getContext('2d');
			var maxWidth = 360;
			var lineHeight = 24;
			var x = (canvas.width - maxWidth) / 2;
			var y = 80;
			if(vueApp.exhibitionLayout.open){
			this.ctx.fillStyle = "#009977";
			}else{
				this.ctx.fillStyle = "#007799";
			}
			
			
			this.ctx.lineWidth = 5;
			this.ctx.rect(0, 0, 400, 300);
			this.ctx.fill();
			
			this.ctx.font = '26pt Arial';
			this.ctx.fillStyle = '#ffffff';
			this.ctx.textAlign = "center";
			this.ctx.fillText(heading.toUpperCase(), 200, 70);
			this.ctx.font = '22pt Arial';
			if(vueApp.exhibitionLayout.open){
				this.ctx.fillText("Exhibition Open", 200, 120);
			}else{
				this.ctx.fillText("Exhibition Closed", 200, 120);
			}
			
			  
			},
			writeText(heading,text){
			
			var canvas = document.createElement('canvas');
			canvas.width = 400;
			canvas.height = 300;
			//var canvas = document.getElementById(canvasID);
			this.ctx = canvas.getContext('2d');
			var maxWidth = 360;
			var lineHeight = 24;
			var x = (canvas.width - maxWidth) / 2;
			var y = 80;
			this.ctx.fillStyle = "#ffffff";
			
			this.ctx.strokeStyle = '#000000';
			this.ctx.lineWidth = 5;
			this.ctx.rect(0, 0, 400, 300);
			this.ctx.fill();
			this.ctx.stroke();
			this.ctx.font = '18pt Arial';
			this.ctx.fillStyle = '#000000';
      		this.wrapText(this.ctx, heading,text, x, y, maxWidth, lineHeight);
			},
			wrapText(context, heading,text, x, y, maxWidth, lineHeight) {
				var words = text.split(' ');
				
				var line = '';
				context.fillText(heading.toUpperCase(), x, 50);
				for(var n = 0; n < words.length; n++) {
					var testLine = line + words[n] + ' ';
					var metrics = context.measureText(testLine);
					var testWidth = metrics.width;
					if (testWidth > maxWidth && n > 0) {
						context.fillText(line, x, y);
						line = words[n] + ' ';
						y += lineHeight;
					}else {
						line = testLine;
					}
				}
				context.fillText(line, x, y);
			},
			
			loadModel(target,opts){
				if(true){
					this.loadName="Loading Item"
					//no spaces
					var material
					var self=this
				
				loadingModel=true
				let modelPath='./models/beaufort/wreckTrim.gltf'
				if(opts.modelFB){
					modelPath=opts.modelFB
				}else if(opts.model){
					if(opts.model.indexOf("media&token")>0){
						modelPath=this.fireBaseLoc+"wrecks%2F"+opts.model
					}else{
						modelPath='./models/'+opts.model+'.gltf'
					}
					
				}
				let instance
				let textureMap
				
				
				const loaderM = new GLTFLoader();
				this.loadingCount++
					loadingModel=true
				loaderM.load(modelPath, gltfM => {
					
					
					console.log("loading ",modelPath,this.loadedCount,'of',this.loadingCount)
					gltfM.scene.traverse( child => {
						if ( child.material) {
							if(child.name=="Cylinder"){
								var material = new THREE.MeshPhongMaterial({
								emissive: 0x0099ff,
								emissiveIntensity:.9,
								//doubleSided:true,
								depthWrite: false,
								opacity: 0.8,
								transparent: true,
							});
							}else if(!opts.solid){
							var material = new THREE.MeshPhongMaterial({
								emissive: 0x0099ff,
								//emissive:0xffffff,
								emissiveIntensity:1,
								//doubleSided:true,
								depthWrite: false,
								//emissiveIntensity:.9,
								opacity: 0.7,
								transparent: true,
							});
							}else{ 
							var material = new THREE.MeshPhongMaterial({
								//emissive: 0x0099ff,
								emissive:0xffffff,
								emissiveIntensity:1,
								//doubleSided:true,
								//emissiveIntensity:.9,
								opacity: 1,
								transparent: false,
							});
							}
							
							if(child.material.map){
								textureMap=child.material.map
								child.material=material
								child.material.map=textureMap
								child.material.emissiveMap=textureMap
							}
							
							if(child.name=="Torus" || opts.glow){
							let spotLight = new THREE.SpotLight( 0x0099ff);
										spotLight.intensity=.9
										spotLight.angle = Math.PI 
										spotLight.penumbra =1;
										spotLight.distance = 100;
								
										child.add( spotLight );
										spotLight.position.set( 0, 0, 0 );
								
										child.add( spotLight.target );
										spotLight.target.position.set(0, 30, 0 );
							}
						}
						
						
					})
					
					if(target==plinthC){
					
						holoModel=gltfM.scene
						
					}
					target.add(gltfM.scene)
					if(opts.name){
						gltfM.scene.name=opts.name
					}
					opts.posX=opts.posX || 0
					opts.posZ=opts.posZ || 0
					if(!isNaN(opts.posY)){
						gltfM.scene.position.set(opts.posX,opts.posY,opts.posZ)
					}else{
						gltfM.scene.position.set(opts.posX,50,opts.posZ)
					}
					
					
					if(opts.rotX){
						gltfM.scene.rotateX(opts.rotX)
					}
					if(opts.rotY){
						gltfM.scene.rotateY(opts.rotY)
					}
					if(opts.rotZ){
						gltfM.scene.rotateZ(opts.rotZ)
					}
					if(opts.scale){
						gltfM.scene.scale.set(opts.scale,opts.scale,opts.scale)
					}else{
						gltfM.scene.scale.set(50,50,50)
					}
					if(opts.interactive){
						interactive=interactive.concat(gltfM.scene.children)
						interactive.push(gltfM.scene)
						console.log("interactive",interactive,gltfM.scene.children)
					}
					if(opts.name=="Sign"){
						vueApp.openSign=gltfM.scene.children[2]
						console.log("Change the sign",gltfM.scene.children[2])
						vueApp.writeSign(vueApp.wreck.name )
							var cTexture=  new THREE.CanvasTexture(vueApp.ctx.canvas);
							var label = new THREE.MeshBasicMaterial({ map:cTexture}) 
							vueApp.openSign.material=label
							vueApp.openSign.material.map.flipY=false
					}
					
					self.loadedCount++
					console.log("ITEM LOADED",self.loadedCount,'of',self.loadingCount)
					if(self.loadedCount==self.loadingCount){
						loadingModel=false;
					}else{
						loadingModel=true;
					}
					if(self.hasVideo){
							self.video.play()
							self.video.volume=self.volume
						}
					//scene.add(gltfM.scene);
					},
					this.loadProg,this.loadError)
					//*** */
				}
					
			},
			loadRoomModel(){
				//no spaces
				
				loadingModel=true
				this.loadName="Loading Room"
				let modelPath='./models/EXIBITION 02.gltf'
				//let modelPath='./models/LIGHTHOUSE.gltf'
				let instance
				let num
				let opts
				
				console.log("loading ",modelPath)
				const loaderX = new GLTFLoader();
				// <video id="video" width=600 loop autoplay :src="wreckVid"  controls style="opacity:0.2;z-index:1000;position:absolute;display:none;"></video>
   
				this.video = document.createElement('video');
				this.video.setAttribute('crossorigin', 'anonymous');
				this.video.width=600
				this.video.loop=true
				
				this.video.src=this.wreckVid
				this.video.volume=this.volume
				//var video = document.getElementById( 'video' );
				
				var videoTexture = new THREE.VideoTexture( this.video );
				var mat = new THREE.MeshPhysicalMaterial({
						  emissive: 0x999999, 
						 emissiveMap: videoTexture,
						 //map:videoTexture,
						 //needsUpdate:true
				}) 
				
				
				videoTexture.minFilter = THREE.LinearFilter;
				videoTexture.magFilter = THREE.LinearFilter;
				videoTexture.format = THREE.RGBFormat;
				this.loadingCount++
					loadingModel=true
					this.loadName="Loading Room"
				loaderX.load(modelPath, gltf => {
					
					console.log("LOAD",modelPath,this.loadedCount,"of",this.loadingCount)
					gltf.scene.traverse( child => {
						if ( child.material ) {
							
							if(child.name=="Screen"){
									
									screen1=child
									child.material=mat
									child.scale.z=-1		
									child.rotateZ(Math.PI)
									this.screenOpts.model=screen1
									child.name=this.screenOpts.name
									interactive.push(child)
									
							}
							if(child.name=="PLINTH_CENTRAL"){
									plinthC=child
									
									
							}
							
							if(child.name=="PLINTH_01"){
									plinth1=child
									var geometry = new THREE.BoxGeometry( .1, 22, 30 );
									var material = new THREE.MeshBasicMaterial( {color: 0x00ff00} );
									var cube = new THREE.Mesh( geometry, material );
									child.add( cube );
									cube.position.set(-90,60,0)
									cube.scale.y=-1
									this.plinthOpts.model=plinth1
									plinthF=plinth1.clone()
									this.floorOpts.model=plinthF
									
									
							}else if(child.name=="Frame_01"){
									frame1=child
									var path = 'beaufort/bomberBP2.png'
									var texture = new THREE.TextureLoader().load(require( '../assets/images/exhibit/beaufort/poster.jpg' ));
									var materialT = new THREE.MeshBasicMaterial( { map: texture } );
									frame1.material=materialT
									frame1.scale.y=-1
									var geometry = new THREE.BoxGeometry( .1, 22, 30 );
									var material = new THREE.MeshBasicMaterial( {color: 0x00ff00} );
									var cube = new THREE.Mesh( geometry, material );
									child.add( cube );
									cube.position.set(0,0,-60)
									cube.scale.y=-1
									this.frameOpts.model=frame1
									
									
							}else if(child.name=="SPOTLIGHT_01"){
									spot1=child
									this.plinthOpts.lightType=spot1
							}else if(child.name=="SPOTLIGHT_06"){
									frameSpot1=child
									this.frameOpts.lightType=frameSpot1
							}else if(child.name.indexOf("PLINTH_0")>-1 ){
								child.position.set( 0, -10000, 0 );
								return
								
							}else if(child.name.indexOf("Frame_0")>-1 ){
								child.position.set( 0, -10000, 0 );
								return
							}
							instance=child.name.split("_")
							
							if(instance[0]=="SPOTLIGHT" ){
								//gltf.scene.remove(child)
								if(child.name!="SPOTLIGHT_01" && child.name!="SPOTLIGHT_06" && child.name!="SPOTLIGHT_14"&& child.name!="SPOTLIGHT_13"){
									child.position.set( 0, -10000, 0 );
								 	return
								}
								if(child.name=="SPOTLIGHT_14"){
									this.addSpotLight(child,-25,6,.5)
								}
								if(child.name=="SPOTLIGHT_13"){
									this.addSpotLight(child,25,6,.5)
								}
							}
							//child.material.wireframe=true
							child.material.metalness = 0;
						}
						
					})
					if(plinth1 && spot1){
						
						let opts
						opts=this.plinthOpts
						
						opts=this.screenOpts
						screen1.position.set(plinth1.position.x-opts.objOffsetX,screen1.position.y,plinth1.position.z)
						screen1.rotation.y=0
						opts=this.frameOpts
						frame1.position.set(plinth1.position.x-opts.objOffsetX,frame1.position.y,plinth1.position.z)
						frameSpot1.position.set(spot1.position.x,spot1.position.y,spot1.position.z)
						frameSpot1.rotateY(Math.PI)
						opts=this.plinthOpts
						
						//Left Wall
						this.plinthOpts.objOffsetX=0
						this.frameOpts.objOffsetX=0
						if(this.exhibitionLayout.leftItems){
							this.layOutWall(this.exhibitionLayout.leftItems,{roomX:0,roomZ:0,lightX:0,objRot:0,lightRot:0})
						}
						
						
						//Right Wall
						this.plinthOpts.spotTargetX=-2
						this.plinthOpts.objOffsetX=0
						this.screenOpts.objOffsetX=0
						this.frameOpts.objOffsetX=90
						if(this.exhibitionLayout.rightItems){
							this.layOutWall(this.exhibitionLayout.rightItems,{roomX:560,roomZ:0,lightX:475,objRot:Math.PI,lightRot:Math.PI})
						}
						//Front Wall
						this.plinthOpts.spotTargetX=2
						this.frameOpts.objOffsetX=130
						this.frameOpts.objOffsetZ=-88
						this.plinthOpts.objOffsetX=40
						if(this.exhibitionLayout.frontItems){
							this.layOutWall(this.exhibitionLayout.frontItems,{roomX:0,roomZ:-742,lightX:100,objRot:-Math.PI/2,lightRot:-Math.PI/2,endWall:true,wallSize:560})
						}
						//Rear Wall
						this.plinthOpts.spotTargetX=2
						this.frameOpts.objOffsetX=130
						this.frameOpts.objOffsetZ=90
						this.screenOpts.objOffsetX=-52
						this.screenOpts.objOffsetZ=90
						
						
						if(this.exhibitionLayout.rearItems){
							let revItems=[]
							for(var i in this.exhibitionLayout.rearItems){
							revItems.push(this.exhibitionLayout.rearItems[i])
						}
						revItems.reverse()
							this.layOutWall(revItems,{roomX:0,roomZ:200,lightX:-130,objRot:Math.PI/2,lightRot:Math.PI/2,endWall:true,wallSize:440})
						}
						plinth1.position.set(plinth1.position.x,plinth1.position.y-1000,plinth1.position.z)
						screen1.position.set(screen1.position.x,screen1.position.y-1000,screen1.position.z)
						frame1.position.set(frame1.position.x,frame1.position.y-1000,frame1.position.z)
						scene.remove(plinth1)
						scene.remove(frame1)
						scene.remove(screen1)
						
						
					}
					
					
					camera.position.y=personHeight
					
					console.log("Room Loaded",this.loadedCount,this.loadingCount)
					scene.add(gltf.scene);
					this.loadModel(scene,{model:"Stantion",name:"Sign",posX:150,posY:1,posZ:250,scale:20,interactive:true})
					if(this.loadExhibitionWreck){
						if(vueApp.wreck && vueApp.wreck.holoWreck){
							this.loadModel(plinthC,{modelFB:this.fireBaseLoc+"wrecks%2F"+vueApp.wreck.holoWreck,scale:.16,posY:25,holo:true,glow:true})
						}else{
							alert("NO MODEL "+vueApp.wreck.holoWreck)
						}
					}
					
					this.loadedCount++
					if(this.loadedCount==this.loadingCount){
						loadingModel=false
					}else{
						loadingModel=true
					}	
				},
				this.loadProg,this.loadError)	
			},
			layOutWall(wallItems,wallOpts){
				let spacing=600/(wallItems.length-1)
				let spacingE=wallOpts.wallSize/(wallItems.length-1)
				let leftPos=0
				let sidePos=0
				let hasLight=true
				let isPlinth=false
				let isFrame=false
				let opts
				if(wallItems.length==1){
					leftPos=250
					spacing=0
					spacingE=300
					sidePos=220
					if(wallOpts.endWall){
						sidePos=250
					}
				}
				if(wallItems.length==2){
					leftPos=50
					spacing=400
					spacingE=300
					sidePos=50
					if(wallOpts.endWall){
						sidePos=100
						spacingE=320
					}
					if(wallOpts.wallSize<500){
						spacingE=180
						sidePos=160
					}
				}
				
				for(var i=0;i<wallItems.length;i++){
					hasLight=true
					isPlinth=false
					isFrame=false
					
							if(wallItems){
								if(wallItems[i].type=="plinth" ){
									
									opts=this.plinthOpts
									opts.objOffsetZ=0
									opts.model.position.y=70
									isPlinth=true
								}else if(wallItems[i].type=="floor"){
									opts=this.plinthOpts
									opts.model.position.y=-12
									isPlinth=true
								}else if(wallItems[i].type=="screen"){
									hasLight=false
									opts=this.screenOpts
									this.hasVideo=true
									
									
								}else{
									opts=this.frameOpts
									isFrame=true
								}
								
							}
							tmpObj=opts.model.clone()
							if(opts.interactive){
								interactive.push(tmpObj)
							}
							if(hasLight){
								tmpLight=opts.lightType.clone()
							}
							if(wallOpts.endWall){
								tmpObj.position.set(opts.model.position.x+wallOpts.roomX+spacingE*i+sidePos+opts.objOffsetX,opts.model.position.y,opts.model.position.z+opts.objOffsetZ+wallOpts.roomZ)
								if(hasLight){
								tmpLight.position.set(opts.lightType.position.x+wallOpts.roomX+spacingE*i+sidePos,opts.lightType.position.y,opts.lightType.position.z+opts.objOffsetZ+wallOpts.roomZ+wallOpts.lightX)
								}
							}else{
								tmpObj.position.set(opts.model.position.x+wallOpts.roomX+opts.objOffsetX*2,opts.model.position.y,opts.model.position.z-spacing*i-leftPos)
								if(hasLight){
									tmpLight.position.set(opts.lightType.position.x+wallOpts.lightX,opts.lightType.position.y,opts.lightType.position.z-spacing*i-leftPos)
								}
							}
							tmpObj.rotateY(wallOpts.objRot)
							if(hasLight){
								tmpLight.rotateY(wallOpts.lightRot)
							
							this.addSpotLight(tmpLight,opts.spotTargetX,opts.spotAngle)
							}
							let photos=vueApp.photos
							if(isFrame){
								var path =  wallItems[i].path || 'beaufort/map.jpg'
								
								if( wallItems[i].type=="photo"){
									wallItems[i].photoIndex = wallItems[i].photoIndex || 0
									if(vueApp.defaultImage){
										
										var texture = new THREE.TextureLoader().load(require( '../assets/images/photos/'+photos[wallItems[i].photoIndex] ))
									}else{
										console.log("Photo data")
										var texture = new THREE.TextureLoader().load(photos[wallItems[i].photoIndex])
										console.log(photos[wallItems[i].photoIndex])
										//var texture= new THREE.Texture(vueApp.photos[wallItems[i].photoIndex])
									}
									
								}else{
									var texture = new THREE.TextureLoader().load(require( '../assets/images/exhibit/'+path ));
								}
									
									var materialT = new THREE.MeshBasicMaterial( { map: texture } );
									tmpObj.scale.z=wallItems[i].scaleX || 1
									tmpObj.material=materialT
									if(wallItems[i].scaleX<1){
										tmpObj.children[0].position.z=tmpObj.children[0].position.z*(1/wallItems[i].scaleX || 1)
									}
									if(wallItems[i].useCard){
										this.writeText(wallItems[i].name,wallItems[i].card )
										var cTexture=  new THREE.CanvasTexture(this.ctx.canvas);
										var label = new THREE.MeshBasicMaterial({ map:cTexture}) 
										tmpObj.children[0].material=label
										tmpObj.children[0].scale.z=1/wallItems[i].scaleX || 1
									}else{
										tmpObj.remove(tmpObj.children[0])
									}
							}
							if(isPlinth){
								if(wallItems[i].path){
									let scale=wallItems[i].scale || 200
									let rotX=wallItems[i].rotX || 0 //Math.PI/2
									let rotY=wallItems[i].rotY ||  Math.PI/2
									let rotZ=wallItems[i].rotZ || 0 //-Math.PI/2
									let solid= true
									if(wallItems[i].solid === false){
										solid=false
									}
									
									this.loadModel(tmpObj,{model:wallItems[i].path,posY:18,scale:scale,rotX:rotX,rotY:rotY,rotZ:rotZ,solid:solid})
						
								}else{
									this.loadModel(tmpObj,{model:"beaufort/skull",posY:25,scale:200,rotX:Math.PI/2,rotZ:-Math.PI/2})
						
								}
								if(wallItems[i].useCard){
									this.writeText(wallItems[i].name,wallItems[i].card )
									console.log("WALL-",wallItems[i])
									var cTexture=  new THREE.CanvasTexture(this.ctx.canvas);
									var label = new THREE.MeshBasicMaterial({ map:cTexture}) 
									tmpObj.children[0].material=label
									tmpObj.children[0].scale.y=1
								}else{
										tmpObj.remove(tmpObj.children[0])
									}
								
									}
							scene.add(tmpObj)
							if(hasLight){
								scene.add(tmpLight)
							}
						}
			},
			addSpotLight(spot,offsetX,spotAngle,intensity){
				intensity=intensity || .4
				let spotLight = new THREE.SpotLight( 0xffffff);
										spotLight.intensity=intensity
										spotLight.angle = Math.PI / spotAngle;//12
										spotLight.penumbra =1;
										spotLight.distance = 1000;
								
										spot.add( spotLight );
										spotLight.position.set( 0, 0, 0 );
								
										spot.add( spotLight.target );
										spotLight.target.position.set( offsetX, -30, 0 );
			},
			checkStatus(){
				
				this.loadingModel=loadingModel
				this.position.x=Math.floor(position.x)
				this.position.y=Math.floor(position.y)
				this.position.z=Math.floor(position.z)
				this.north=rotation
				this.rotInfo=rotation
				//console.log("Status",this.position.z)
				this.distance=Math.floor(Math.sqrt(this.position.x*this.position.x+this.position.z*this.position.z))
				this.rotation=(Math.atan2(this.position.z - 0, this.position.x - 0) * 180 / Math.PI-90)
				
				if(this.position.z>560){
					this.leavingExhibit=true
					if(this.position.z>600){
						 this.leavingExhibit=false
						 this.video.pause()
						 if(this.exhibitMode=="preview"){
							  this.$store.dispatch('startTransition',{text:"Back at the drawing board",to:"exhibitPlan"})
						 }else{
							 this.$store.dispatch('startTransition',{text:"Back at the Lighthouse",to:"game"})
						 }
						 
					}else{
						if(isRunning){
						requestAnimationFrame( this.checkStatus );
						}
					}
				}else{
					this.leavingExhibit=false
					if(isRunning){
					requestAnimationFrame( this.checkStatus );
					}
				}
			},
			loadError(e){
				console.error(e)
			},
			loadProg(p){
				
				this.loadProgress=Math.min(100,Math.floor(p.loaded/p.total*100))
				if(this.loadedCount==this.loadingCount && this.loadProgress>99){
						loadingModel=false;
					}else{
						loadingModel=true;
					}
			},
		keyUp(e){
				switch(e.key){
					case " ":
						console.log("pause")
						this.paused=!this.paused
						paused=this.paused
						break
				
				}
			}
	   
		},
		watch:{
			debug(val){
				if(val){
					
					container.appendChild( stats.dom );
				}else{
					container.removeChild( stats.dom );
				}
			},
			exhibitionLoaded(val){
				
				 if(val){
					 console.log("EXHIBIT LAYOUT",this.exhibitionLayout,this.activeWreck)
					this.startScene()
				 }
			},
			wrecks(val){
          console.log("============ Wrecks",val)
        if(this.activeWreck){
			this.$store.commit('setWreckByName',this.activeWreck)
			console.log("GET THE EXHIBIT")
			this.$store.dispatch('getExhibition')
			}
       	},
			volume(val){
				this.video.volume=val
			}
		},
		beforeDestroy(){
			document.removeEventListener('keyup', this.keyUp);
			//document.removeEventListener( 'mousedown', onDocumentMouseDown );
			document.removeEventListener( 'mousedown', onMouseDown, false );
			controls.dispose()
			if(this.hasVideo){
							this.video.pause()
						}
			isRunning=false
			if ( gui ) gui.destroy();
		}
	};



			import * as THREE from 'three';
			
			import Stats from 'three/examples/jsm/libs/stats.module.js';
			import * as dat from 'dat.gui';
			import { DxPopup } from 'devextreme-vue/popup';
			

		
			

import {ImprovedNoise} from 'three/examples/jsm/math/ImprovedNoise.js';
import gsap from "gsap";

			import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
			import { FirstPersonControlsTouch } from 'three/examples/jsm/controls/FirstPersonControlsTouch.js';
import AppVue from '../App.vue';
		
			var isRunning=false
			var vueApp
			var position={x:0,y:0,z:0}
			var rotation=0
			var personHeight=150
			//
			var camera, scene, renderer, composer;
			var object, Alight, spotLight;
			var interactive=[]
			
			var container
			var controls
			var params
			var clock = new THREE.Clock();
			var stats,gui
			
			var loadedModel
			var holoModel
			//
			var texture, worldWidth = 1024, worldDepth = 1024,
			  worldHalfWidth = worldWidth / 2, worldHalfDepth = worldDepth / 2;
			  
			 var plinth1,plinthC,plinthF
			 var tmpObj,tmpLight
			 var spot1
			 var frame1
			 var frameSpot1
			 var screen1
			var raycaster,mouse
			//init();
			//animate();

			function init() {
				console.log("INIT")
				container = document.getElementById( 'container' );
				renderer = new THREE.WebGLRenderer();
				renderer.setPixelRatio( window.devicePixelRatio );
				renderer.setSize( window.innerWidth, window.innerHeight );
				container.appendChild( renderer.domElement );
				
				//document.body.appendChild( renderer.domElement );

				//

				camera = new THREE.PerspectiveCamera( 55, window.innerWidth / window.innerHeight, 1, 3000 );
				
				camera.position.z = 560;
				camera.position.x = 300;
				scene = new THREE.Scene();
				
				object = new THREE.Object3D();

				raycaster = new THREE.Raycaster();
				mouse = new THREE.Vector3();
				window.addEventListener( 'mousemove', onMouseMove, false );
				document.addEventListener( 'mousedown', onMouseDown, false );

				controls = new FirstPersonControlsTouch( camera, document );
				controls.movementSpeed = 100;
				controls.lookSpeed = 0.05;

				var geometry = new THREE.SphereBufferGeometry( 1, 4, 4 );
				var materialX = new THREE.MeshPhongMaterial( { color: 0xffffff, flatShading: true } );
				var material = new THREE.MeshBasicMaterial( {

						color: 0x00e0ff,
						wireframe: true

					} );
				
				Alight = new THREE.AmbientLight( 0x222222 ); // soft white light
				scene.add( Alight );
				
                scene.fog = new THREE.FogExp2( 0x000000, 0.0005);
				
				
				
				
			
				

				//Stats
		stats = new Stats();
		if(vueApp.isTester){
			//container.appendChild( stats.dom );
		
		
		// GUI
		createGUI()
		}	

				 

			
			

		
			

			window.addEventListener( 'resize', onWindowResize, false );

			}
			
			function loadModel(gltfPath,options){
				
				vueApp.loadingCount++
				loadingModel=true
				// Model Loader
				console.log("---------      PATH",gltfPath)
				const loader = new GLTFLoader();
				// all files referenced in the gltf file have now also been resolved by your loaders.
				loader.load(gltfPath, gltf => {
					loadedModel=gltf
					const clips = gltf.animations || [];
					// called when the resource is loaded
					if(options.position){
						gltf.scene.position.set(options.position[0],options.position[1],options.position[2])
					}
					if(options.trace){
						gltf.scene.traverse( child => {
							console.log("pre-",child)
							if ( child.material ) {
								
								child.material.color = new THREE.Color(0,.5,0)
								child.material.emissive=new THREE.Color(0,.5,0)
								child.material.emissiveIntensity = 0
								child.material.roughness =1
								child.material.envMapIntensity = 0
								
							}
							console.log("post",child)
						} );
					}
					if(options.fixMetal){
						gltf.scene.traverse( child => {
							if ( child.material ) child.material.metalness = 0;
						} );
					}
					if(options.scale){
						if(options.scale.length>1){
							gltf.scene.scale.set(options.scale[0],options.scale[1],options.scale[2])
						}else{
							gltf.scene.scale.set(options.scale,options.scale,options.scale)
						}
					}
			
					if(options.onLoad){
						options.onLoad(gltf.scene,gltf.animations)
					}else{
						vueApp.loadedCount++
						if(vueApp.loadedCount==vueApp.loadingCount){
							loadingModel=false;
						}else{
							loadingModel=true;
						}
						
						console.log("LOADED",gltf,vueApp.loadedCount)
						scene.add( gltf.scene );
					
					}
		},
		( xhr ) => {
			// called while loading is progressing
			if(vueApp.loadedCount==vueApp.loadingCount){
				loadingModel=false;
			}else{
				loadingModel=true;
			}
			console.log("LOAD")
			console.log( `${( xhr.loaded / xhr.total * 100 )}% loaded` );
		},
		( error ) => {
			// called when loading has errors
			console.log("Error Loaded")
			loadingModel=false
			console.error( 'An error happened', error );
		});
	}
			
			function setWireFrame(val){
				if(loadedModel){
					loadedModel.scene.traverse( child => {
					if ( child.material ) {
						child.material.wireframe=val
						
					}
				})
				}
			}
			function onMouseMove() {
				mouse.x = ( event.clientX / renderer.domElement.clientWidth ) * 2 - 1;
				mouse.y = - ( event.clientY / renderer.domElement.clientHeight ) * 2 + 1;
				

				
			}	
			function onWindowResize() {

				camera.aspect = window.innerWidth / window.innerHeight;
				camera.updateProjectionMatrix();

				renderer.setSize( window.innerWidth, window.innerHeight );
			

			}
			
			function animate() {
				if(isRunning){
					requestAnimationFrame( animate );
					//console.log("EX")
					update()
				}
			}
			function onMouseDown(e){
				
				console.log("DOWN",interactive )
				raycaster.setFromCamera( mouse, camera );
				var intersects = raycaster.intersectObjects( interactive );
				for ( var i = 0; i < intersects.length; i++ ) { 
					console.log("HIT",intersects[0].object)
					if(intersects[0].object.name=="Screen"){
						if(vueApp.video.paused){
							vueApp.video.play()
						}else{
							vueApp.video.pause()
						}
						
						//alert("SCREEN")
					}else if(intersects[0].object.parent){
							if(intersects[0].object.parent.name=="Sign"){
								vueApp.openCTA()
							}
							console.log(intersects[0].object.parent.name)
						
					}
					
				}
			}
			function update() {
				
				 position=camera.position
				 
				 rotation=camera.rotation
				 var dir = new THREE.Vector3();
				var sph = new THREE.Spherical();

				camera.getWorldDirection(dir);
				sph.setFromVector3(dir);
				rotation=THREE.Math.radToDeg(sph.theta) - 180
				
				
				var time = performance.now() * 0.001;
				var deltaTime=clock.getDelta()
			
			
				if(!paused){
					if(holoModel ){
					  holoModel.rotation.y += 0.005;
				}
				//object.rotation.x += 0.005;
				//object.rotation.y += 0.01;
				
				 controls.update( deltaTime );
				}
				camera.position.x=Math.min(camera.position.x,350)
				camera.position.x=Math.max(camera.position.x,-250)
				camera.position.z=Math.max(camera.position.z,-350)
				camera.position.y=personHeight
				stats.begin();

	// monitored code goes here

	stats.end();
				renderer.render( scene, camera );
				
			}
				function createGUI(){
		// GUI
		
		if ( gui ) {
			 try{
				gui.destroy();
			}
			catch(err){
			}	
		}
		
	class FogGUIHelper {
    		constructor(fog, backgroundColor) {
      			this.fog = fog;
      			this.backgroundColor = backgroundColor;
    		}
			get near() {
				return this.fog.near;
			}
			set near(v) {
				this.fog.near = v;
				this.fog.far = Math.max(this.fog.far, v);
			}
			get far() {
				return this.fog.far
			}
			set far(v) {
				this.fog.far = v;
				this.fog.near = Math.min(this.fog.near, v);
			}
			get color() {
				return `#${this.fog.color.getHexString()}`;
			}
			set color(hexString) {
				this.fog.color.set(hexString);
				this.backgroundColor.set(hexString);
			}
		}						
  	
		const color = '#000000';
		const near = 1;
		const far = 5000;
		scene.fog = new THREE.Fog(color, 0, 2000);
		scene.background = new THREE.Color(color);
		const fogGUIHelper = new FogGUIHelper(scene.fog, scene.background);
   
  if(vueApp.debug){
		gui = new dat.GUI();
		var fogOptions={
			color:scene.fog.color
		}
		params={
			showWireFrame:false,
			
			
		}
		var folder = gui.addFolder( 'Global Light' );
		folder.add( Alight, 'intensity', 0, 4, .1 ).name( 'Ambient Light' );
		
		
		var folderFog = gui.addFolder( 'Fog' );
		folderFog.add(fogGUIHelper, 'near', near, far).listen();
   		folderFog.add(fogGUIHelper, 'far', near, far).listen();
		folderFog.addColor(fogGUIHelper, 'color');
		
		
		
		
		


			folder.open();
		//
	}
				}
	//

		</script>


<style scoped>
	.CTA{
		position:absolute;
		visibility:hidden;
		opacity:0;
		width:100%;
		height:100%;
		top:0px;
		color:#fff;
		background-color: #000000aa;
	}
	.CTA h2{
		margin-top:20%
	}
	.CTA button{
		padding: 10px;
    margin: 10px;
    border-radius: 5px;
    font-family: "Orbitron";
	
	}
	
</style>